import React from 'react'
import { Modal } from 'antd'
import { history } from 'umi'

const IS_SUPPLIER = PROJECT_CONFIG.terminalName === PROJECT_CONFIG.supplierTerminalName

const ActionConfirm = ({ content }) => {
    return (
        <div>
            {content ||
                (IS_SUPPLIER
                    ? '分销商品前需要先设置供货价，是否前往设置？'
                    : '分销商不可分销商品，请至供应商侧进行设置')}
        </div>
    )
}

ActionConfirm.show = ({ ...config }) => {
    const { onOk } = config || {}
    return Modal.confirm({
        width: '580px',
        title: '提示',
        content: <ActionConfirm {...({ ...config } || {})} />,
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
            if (onOk) {
                onOk()
            } else {
                IS_SUPPLIER && history.push('/partnerManage/ruleSetting/discountRateConfig')
            }
        }
    })
}

export default ActionConfirm
